import React, { FC, useState } from "react";
import { Routes, Route } from "react-router-dom";
import { IdleTimerProvider } from "react-idle-timer";

import { routeMap } from "@utils/constants";

import HomePage from "@pages/home";
import LoginPage from "@pages/auth/login";
import ForgotPassword from "@pages/auth/forgot-password";
import ResetPassword from "@pages/auth/reset-password";
import Members from "@pages/members";
import UploadFile from "@pages/uploadFiles";
import Dashboard from "@pages/dashboard";
import HipDashboard from "@pages/CM-Lite/Hip-Dashboard/HipDashboard";

import AuthGaurd from "./auth-guard";
import MemberProfile from "@pages/member-details";
import CMAdmin from "@pages/cm-admin";
import UploadContextProvider from "@context/uploadProvider";
import CustomModal from "@components/modal";
import EMPI from "@pages/empi/empi";

import UserActivityHOC from "./userActivityHOC";

export type RouterProps = {};

const Router: FC<RouterProps> = () => {
  const [sessionTimeoutModal, setSessionTimeoutModal] = useState(false);

  return (
    <>
      <IdleTimerProvider timeout={Number(process.env.REACT_APP_INACTIVITY_TIMEOUT_TIME)} crossTab={true} leaderElection={true}>
        <UserActivityHOC setSessionTimeoutModal={setSessionTimeoutModal}>
          <UploadContextProvider>
            {sessionTimeoutModal && <CustomModal visible={sessionTimeoutModal} setVisible={setSessionTimeoutModal} />}
            <Routes>
              <Route path={routeMap.login} element={<LoginPage />} />
              <Route path={routeMap.ssoRedirect} element={<LoginPage />} />
              <Route
                path={routeMap.home}
                element={
                  <AuthGaurd>
                    <HomePage />
                  </AuthGaurd>
                }
              />
              <Route
                path={routeMap.members}
                element={
                  <AuthGaurd>
                    <Members />
                  </AuthGaurd>
                }
              />
              <Route
                path={routeMap.dashboard}
                element={
                  <AuthGaurd>
                    <Dashboard />
                  </AuthGaurd>
                }
              />
              <Route
                path={routeMap.setting}
                element={
                  <AuthGaurd>
                    <Dashboard />
                  </AuthGaurd>
                }
              />
              <Route
                path={routeMap.upload}
                element={
                  <AuthGaurd>
                    <UploadFile />
                  </AuthGaurd>
                }
              />
              <Route
                path={routeMap["care-lite"]}
                element={
                  <AuthGaurd>
                    <HipDashboard />
                  </AuthGaurd>
                }
              />
              <Route path={routeMap["forgot-password"]} element={<ForgotPassword />} />
              <Route path={routeMap["reset-password"]} element={<ResetPassword />} />
              <Route
                path={routeMap.memberProfile}
                element={
                  <AuthGaurd>
                    <MemberProfile />
                  </AuthGaurd>
                }
              />
              <Route
                path={routeMap.cmadmin}
                element={
                  <AuthGaurd>
                    <CMAdmin />
                  </AuthGaurd>
                }
              />
            <Route
              path={routeMap.wellbe}
              element={
                <AuthGaurd>
                  <EMPI />
                </AuthGaurd>
              }
            />
            <Route path={routeMap.wellbe} element={ <AuthGaurd><EMPI /></AuthGaurd>} />

          </Routes>
        </UploadContextProvider>
        </UserActivityHOC>
      </IdleTimerProvider>
    </>
  );
};

export default Router;
